import ArrowForwardIos from '@mui/icons-material/ArrowForwardIosRounded';
import {
  Avatar,
  Card,
  Divider,
  AccordionSummary as MuiAccordianSummary,
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  Typography,
} from '@mui/material';
import styled from 'styled-components';

import {
  BaseColorKeys, SubjectColorKeys,
} from '../../theme';

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  user-select: none;
  min-height: 56px;
`;

interface Expandable {
  $expanded: boolean,
}

const ArrowIcon = styled(ArrowForwardIos)<Expandable>`
  && {
    font-size: 0.9rem;
    color: ${({ $expanded, theme }) => ($expanded ? theme.palette.primary.dark : 'none')}
  }
`;

interface Colorable {
  color: BaseColorKeys | SubjectColorKeys
}

const TitleIcon = styled(Avatar)<Colorable>`
  && {
    background-color: ${({ theme, color }) => theme.palette[color].main};
    margin-right: ${({ theme }) => theme.spacing(2)};
  }
`;

const TitleDivider = styled(Divider)`
  && {
    margin-top: ${({ theme }) => theme.spacing(2)};
    margin-bottom: ${({ theme }) => theme.spacing(2)};
  }
`;

const CardContainer = styled(Card)<Colorable>`
  border-width: ${({ theme }) => theme.spacing(0.5, 0, 0, 0)};
  border-color: ${({ theme, color }) => theme.palette[color].main};
  border-style: solid;
`;

const Accordion = styled(MuiAccordion)`
  && {
    &:not(:first-child) {
      border-top: ${({ theme }) => `1px solid ${theme.palette.divider}`};
    };
    &:before {
      display: 'none';
    };
    background-image: linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05));
  }
`;

const AccordionDetails = styled(MuiAccordionDetails)`
  && {
    padding: ${({ theme }) => theme.spacing(2)};
  }
`;

const AccordionSummary = styled(MuiAccordianSummary)`
  && {
    flex-direction: row-reverse;
    & .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
      transform: rotate(90deg);
    };
    & .MuiAccordionSummary-content {
      margin-left: ${({ theme }) => theme.spacing(1)};
    };
  }
`;

interface VideosListProps {
  isSingleColumn: boolean
}

const VideosList = styled.div<VideosListProps>`
  column-count: ${({ isSingleColumn }) => (isSingleColumn ? 1 : 2)};
`;

const VideosListEntry = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: ${({ theme }) => theme.spacing(1)};
  padding-bottom: ${({ theme }) => theme.spacing(1)};
`;

const VideoIndex = styled(Typography)`
  && {
    font-weight: 500;
    color: ${({ theme }) => theme.palette.primary.dark};
    min-width: 24px;
  }
`;

const VideoLabel = styled(Typography)`
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.palette.primary.dark};
  }
`;

interface TopicLabelProps {
  selected?: boolean,
}

const TopicLabel = styled(Typography)<TopicLabelProps>`
  && {
    font-weight: ${({ selected }) => (selected ? 500 : 'normal')};
    color: ${({ selected, theme }) => (selected ? theme.palette.primary.dark : 'none')}
  }
`;

const TitleStack = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export { TitleDivider,
  CardContainer,
  TitleContainer,
  TitleStack,
  VideosList,
  TitleIcon,
  VideosListEntry,
  VideoIndex,
  VideoLabel,
  Accordion,
  ArrowIcon,
  TopicLabel,
  AccordionDetails,
  AccordionSummary };
